const LOCAL_STORAGE_KEYS = {
    Token: 'token',
    TokenExpirationTime: 'expirationTime',
    Filters: 'filters',
    Language: 'language'
};

export default LOCAL_STORAGE_KEYS;
